import React from 'react';
import { Steps } from 'antd';
import progressDescription from './progressDescription';
import './FormProgress.css';

const { Step } = Steps;

const FormProgress = ({ progress }) => {
  // console.log('progress', progress);
  const idx = progress.find(p => p.completed === false);
  return (
    <div className="b-sidebar-progress">
      <div className="b-sidebar-progress__title">Прогресс заполнения</div>
      <div className="b-sidebar-progress__list">
        <Steps direction="vertical" size="small" current={1}>
          {progress.map((item, index) => {
            return (
              <Step
                key={index}
                title={item.title}
                description={item.completed && progressDescription(item)}
                status={
                  idx && item.name === idx.name
                    ? 'process'
                    : item.completed
                    ? 'finish'
                    : 'wait'
                }
              />
            );
          })}
        </Steps>
      </div>
    </div>
  );
};

export default FormProgress;
